import { gql } from '@apollo/client';

export const UploadUrl = gql`
    mutation uploadUrl($url: String!, $agentId: ID!) {
        uploadUrl(url: $url, agentId: $agentId) {
            ... on UploadedKnowledgeDataSuccessType {
                message
                knowledgeData {
                    id
                    source
                    active
                    sourceType
                    text
                    createdAt
                }
            }
            ... on ErrorType {
                message
            }
        }
    }
`;
